module.exports = __webpack_public_path__ + "img/menu.a2c6323f.svg";